import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { translationPacket } from 'common/actions';
import { Epg } from 'common/constants/data-types';

import { getClassName } from 'common/utils';

interface DescriptionStaffProps {
  actors?: Epg['actors'];
  persons?: Epg['persons'];
  i18n: typeof translationPacket;
  linesDirector?: number;
  linesActors?: number;
  align?: 'left' | 'right';
}

function DescriptionStaff({
  actors,
  persons,
  i18n,
  linesDirector,
  linesActors,
  align = 'right'
}: DescriptionStaffProps) {
  if (isEmpty(persons) && isEmpty(actors)) {
    return null;
  }

  const director = persons?.find((e) => e.function?.toLowerCase() === 'director');

  const renderDirector = () => {
    if (!director) {
      return null;
    }

    return (
      <div className="description-staff-row" data-test-id="description-staff-director">
        <span className={getClassName('description-staff-title', { right: align === 'right' })}>
          {i18n.common.director}:
        </span>
        <div className="description-staff-data" style={{ WebkitLineClamp: linesDirector }}>
          {director.name}
        </div>
      </div>
    );
  };

  const renderActors = () => {
    if (!actors) {
      return null;
    }

    return (
      <div className="description-staff-row" data-test-id="description-staff-actors">
        <span className={getClassName('description-staff-title', { right: align === 'right' })}>
          {i18n.common.actors}:
        </span>
        <span className="description-staff-data" style={{ WebkitLineClamp: linesActors }}>
          {actors.join(', ')}
        </span>
      </div>
    );
  };

  return (
    <div className="description-staff-container">
      {renderDirector()}
      {renderActors()}
    </div>
  );
}

const mapStateToProps = ({ i18n }: any) => ({
  i18n
});

export default React.memo(connect(mapStateToProps, {})(DescriptionStaff));
